import apiFetch from "@wordpress/api-fetch";

export default class WpApi {
  constructor() {
    this.version = "2";
    this.jsonEndpoint = `/wp-json/wp/v${this.version}`;
  }

  /**
   * @param {string} endpoint <cars, car-model, products-producer, products-category>
   * @returns {Promise} Fetch posts by endpoint
   */
  async fetchPosts(endpoint) {
    const data = await apiFetch({ path: `${this.jsonEndpoint}/${endpoint}?parent=0&per_page=-1` }).then((posts) => {
      return posts;
    });

    return data;
  }
}
